import React from 'react';
import { Button, Modal } from 'alurkerja-ui';
import { ICommentSchema } from '@/api/comment';
import { CommentForm } from './CommentForm';
import { ITestIssueSchema } from '@/api/testIssue';
import { FaPen } from 'react-icons/fa6';

interface EditCommentFormProps {
  testIssue: ITestIssueSchema;
  comment?: ICommentSchema;
  onSuccess?: () => void;
}

export const EditCommentForm: React.FC<EditCommentFormProps> = ({
  testIssue,
  comment,
  onSuccess,
}) => {
  return (
    <Modal
      triggerButton={
        <Button>
          <FaPen size={15} />
        </Button>
      }
      title="Edit Comment">
      {({ closeModal }) => (
        <CommentForm
          testIssue={testIssue}
          comment={comment}
          onSuccess={onSuccess}
          closeModal={closeModal}
        />
      )}
    </Modal>
  );
};
